import { ref } from 'vue';
import { getCountryName } from '@/utils/countries';
// ISO-standardized country codes for markets
export var markets = [
    "CA", // Canada
    "FI", // Finland
    "FR", // France
    "SE", // Sweden
    "NO", // Norway
    "NL", // Netherlands
    "DE", // Germany
    "JP", // Japan
    "GB", // United Kingdom
    "ZA", // South Africa
    "ES", // Spain
    "MX", // Mexico
    "NZ", // New Zealand
    "AU", // Australia
    "IT", // Italy
    "RU", // Russia
    "GCC", // Gulf Cooperation Council
    "PT", // Portugal
    "GR", // Greece
    "TH", // Thailand
    "INT" // Placeholder for International
];

export const marketOptions = markets.map(marketCode => ({
    label: marketCode === 'INT' ? 'Global' : getCountryName(marketCode),
    value: marketCode,
    code: marketCode.toLowerCase()
  }));

export function getCountryCode(marketName) {
    const countryCode = marketName;
    if (countryCode !== 'INT') {
        return countryCode.toLowerCase();
    } else return 'globe';
}

export function marketTooltip(markets) {
    return markets.map(market => market).join(', ');
}

export function marketClass(marketName) {
    const countryCode = getCountryCode(marketName);
    
    // Special case for GCC (Gulf Cooperation Council)
    if (countryCode === 'gcc') {
        return 'fi-gcc';  // Custom class for GCC emblem
    }
    
    // Regular country flags
    if (countryCode !== 'globe') {
        return `fi fi-${countryCode}`;
    } else {
        return 'fa fa-globe';  // Fallback to Font Awesome's globe icon
    }
}

export function getDistinctMarketsByName(markets) {
    const distinctMarkets = [];
    markets.forEach(market => {
        if (!distinctMarkets.includes(market.name)) {
            distinctMarkets.push(market.name); // Only add if not already present
        }
    });
    return distinctMarkets;
}

export function getDistinctMarkets(markets) {
    const distinctMarkets = [];
    markets.forEach(market => {
        if (!distinctMarkets.includes(market)) {
            distinctMarkets.push(market); 
        }
    });
    return distinctMarkets;
}